import React, { useEffect } from "react";
import { addPromotedBrandCategoryAdToSessionStorage } from "../addAdsToSessionStorage";
import trackBrandAdService from "../trackBrandAdService";
import PromotedBrandAdType from "../PromotedBrandAdType";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";
import PromotedTag from "~/common/PromotedTag/PromotedTag";
export interface Props {
  link: string;
  image: string;
  name: string;
  childrenAreProducts?: boolean;
  childCount: number;
  type: "category" | "brand";
  isPromotedAd?: boolean;
  user?: User;
  adId?: number;
  mounted: boolean;
  brandIds?: number[];
  categoryId?: number;
  categoryName?: string;
}
const SearchImageBox = ({
  name,
  link,
  image,
  childrenAreProducts,
  childCount,
  type,
  isPromotedAd = false,
  user,
  adId,
  mounted,
  brandIds,
  categoryId,
  categoryName
}: Props) => {
  const subTitle = type === "category" && !childrenAreProducts ? "CATEGORIES" : "PRODUCTS";
  const isRelativeUrlType = categoryId === 0;
  const handleAdClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isPromotedAd) {
      e.preventDefault();
      await trackBrandAdService("click", {
        promotedBrandAdType: PromotedBrandAdType.SearchPromotedBrandCategory,
        adId: adId || -1,
        userId: Number(user?.index) || null,
        sessionId: user?.cfid,
        url: link
      });
      addPromotedBrandCategoryAdToSessionStorage("SearchPromotedBrandCategoryAd", adId, brandIds, categoryId, categoryName, isRelativeUrlType ? link : "");
      window.location.href = link;
    }
  };
  useEffect(() => {
    if (mounted && isPromotedAd) {
      trackBrandAdService("impression", {
        promotedBrandAdType: PromotedBrandAdType.SearchPromotedBrandCategory,
        adId: adId || -1,
        sessionId: user?.cfid,
        userId: Number(user?.index),
        url: link
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mounted]);
  return <div className="ag-item p-2 xs:p-4" data-sentry-component="SearchImageBox" data-sentry-source-file="SearchImageBox.tsx">
      <a href={link} onClick={handleAdClick} data-testid="search-imagebox">
        <div className="h-0 m-0 mb-2 overflow-hidden pb-full relative">
          {isPromotedAd && <div className="bg-white absolute right-0 top-0 z-5 m-1 flex rounded-sm items-center pr-1 bg-opacity-80" id="promotedBrandCategory">
              <PromotedTag />
            </div>}
          <img src={image} alt="" className="absolute inset-0 w-full my-auto" />
        </div>
        <p className="font-semibold h-12 text-xs leading-4 mb-0 max-h-full overflow-hidden sm:text-sm sm:leading-4 whitespace-pre-line">
          {name}
        </p>
        {childCount > 0 ? <p className="block text-2xs leading-4 m-0 relative text-gray-800 uppercase">
            {childCount} {subTitle}
          </p> : <div className="h-4" />}
      </a>
    </div>;
};
export default connectUserAndChat(SearchImageBox);